module.exports = __webpack_public_path__ + "img/bihua01.60ed2bf7.png";